module.exports = __webpack_public_path__ + "img/chestnut_brown.0944e1a.png";